





import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class SupportTooltip extends Vue {
  @Prop({ required: true }) message: string;
}
